import React, { FC, useCallback, useEffect, useRef } from "react";

interface Props {
  children: React.ReactElement<any>;
  clickOutside: (event: any) => void;
}

const ClickOutsideListener: FC<Props> = (props: Props) => {
  const { children, clickOutside } = props;
  const childRef = useRef(null);

  const eventHandler = useCallback(
    (event: any) => {
      if (!childRef.current) {
        return;
      }

      if (
        document.contains(event.target) &&
        !childRef.current.contains(event.target)
      )
        clickOutside(event);
    },
    [clickOutside]
  );

  useEffect(() => {
    document.addEventListener("click", eventHandler);

    return () => {
      document.removeEventListener("click", eventHandler);
    };
  }, [eventHandler]);

  return React.cloneElement(children, { ref: childRef });
};

export default ClickOutsideListener;
